module.exports = __webpack_public_path__ + "img/02.21c36f65.png";